import GiftCard from "@/features/GiftCard/GiftCard";
import { withTeamConfig } from "@/global/context/AppProviderRoot";
import { useRouterExtended } from "@/global/hooks/useAppSystem";
import useDisabledRoutesHandlers from "@/global/hooks/useDisabledRoutesHandlers";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { routes } from "@/global/routes";
import { Box, CircularProgress, Stack } from "@mui/material";
import React from "react";

const GiftCardPage = () => {
  const router = useRouterExtended();
  const { teamSchema } = useTeamConfig();
  const { isLoading } = useDisabledRoutesHandlers();

  React.useEffect(() => {
    router.push({
      pathname: routes.gift,
      query: { teamSchema },
    });
  }, []);

  if (isLoading)
    return (
      <Box height={"100vh"}>
        <Stack
          width={"100%"}
          height="100vh"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <CircularProgress size={"64px"} color="primary" />
        </Stack>
      </Box>
    );

  return null;
};

export default withTeamConfig(GiftCardPage);
